import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineArrowLongLeft } from "react-icons/hi2";
import useStore from "../../../features/store";
import Loading from "../../common/loading";
import DatePickerInput from "../../form/datePicker";
import FilterIcon from "../../../assets/icons/filter.svg";
import CalendarIcon from "../../../assets/icons/calendar.svg";
import { formateDateToGregorian } from "../../../utils/Functions";
import Modal from "../../common/modal";

const Statistics = ({
  fetchBirthyearStatsData,
  fetchStaticData,
  statistical,
  isLoadingStatistical,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  isLoadingBirthyearStats,
  messagesTickets,
  isLoadingMessages,
  invalidComponents,
  isLoadingInvalidComponents,
}: any) => {
  const navigate = useNavigate();
  //@ts-ignore
  const { profile } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const statisticsData = [
    {
      title: "تعداد کاربران",
      subtitle: "تعداد کل کاربران بادی‌بان",
      content: statistical?.users_count ?? "-",
      link: "/dashboard-profiles?page=1",
    },
    {
      title: "تعداد تست‌ها",
      subtitle: "تعداد کل تست‌های ثبت شده در بادی‌بان",
      content: statistical?.test_count ?? "-",
      link: "/dashboard-tests?page=1",
    },
    {
      title: "کاربران فعال",
      subtitle: "تعداد منحصربه‌فرد کاربرانی که تست ثبت کرده‌اند",
      content: statistical?.unique_users_with_test ?? "-",
      link: "",
    },

    {
      title: "پیام‌ها",
      subtitle: "‌پیام‌‌ها و نظراتی که برای بادی‌بان ثبت شده است",
      content: messagesTickets?.count ?? "-",
      link: "/dashboard-messages?model=contact-us",
    },
    {
      title: "فاکتورهای استخراج‌ نشده",
      subtitle: "فاکتورهایی که تاکنون از آزمایش‌ها استخراج‌ نشده",
      content: invalidComponents?.invalid_components?.length ?? "-",
      link: "/dashboard-invalid-components",
    },
  ];

  const comparisonData = [
    {
      title: "فیدبک آزمایش‌ها",
      subtitle: "فیدبک‌های ثبت شده برای آزمایش‌ها",
      link: "/dashboard-messages?model=feedback",
      data: [
        {
          title: "مثبت",
          content: statistical?.good_feedback ?? "-",
        },
        {
          title: "منفی",
          content: statistical?.bad_feedback ?? "-",
        },
      ],
    },

    {
      title: "جنسیت کاربران",
      subtitle: "درصد کاربران به تفکیک جنسیت",
      link: "",
      data: [
        {
          title: "زن",
          content: `${
            Number(statistical?.percentage_female_user).toFixed(1) ?? "-"
          }%`,
        },
        {
          title: "مرد",
          content: `${
            Number(statistical?.percentage_male_user).toFixed(1) ?? "-"
          }%`,
        },
      ],
    },
    {
      title: "نام کاربران",
      subtitle: "تفکیک کاربران به تفکیک نام",
      link: "",
      data: [
        {
          title: "دارای نام",
          content: statistical?.users_with_name ?? "-",
        },
        {
          title: "بدون نام",
          content: statistical?.users_without_name ?? "-",
        },
      ],
    },
    {
      title: "جنسیت کاربران",
      subtitle: "تفکیک کاربران به تفکیک جنسیت",
      link: "",
      data: [
        {
          title: "دارای جنسیت",
          content: statistical?.users_with_gender ?? "-",
        },
        {
          title: "بدون جنسیت",
          content: statistical?.users_without_gender ?? "-",
        },
      ],
    },
    {
      title: "تاریخ تولد کاربران",
      subtitle: "تفکیک کاربران به تفکیک تاریخ تولد",
      link: "",
      data: [
        {
          title: "دارای تاریخ ",
          content: statistical?.users_with_brith_day ?? "-",
        },
        {
          title: "بدون تاریخ ",
          content: statistical?.users_without_brith_day ?? "-",
        },
      ],
    },
  ];

  const Card = ({ title, subtitle, content, bgColor, color, link }: any) => {
    return (
      <div
        className={`${bgColor} rounded-xl p-3 lg:p-6 flex items-center justify-between`}
        onClick={() => link && navigate(link)}
      >
        {isLoadingStatistical || isLoadingBirthyearStats ? (
          <Loading />
        ) : (
          <>
            <div className="flex-2 lg:pl-5">
              <h3
                className={`font-rokh font-[900] text-lg flex items-center ${color}`}
              >
                {title}
                {link && (
                  <Link to={link}>
                    <HiOutlineArrowLongLeft
                      size={19}
                      className="mr-[6px] -mt-1"
                    />
                  </Link>
                )}
              </h3>
              <p className={`text-sm ${color}`}>{subtitle}</p>
            </div>
            {content !== "" && (
              <h2 className="min-w-[80px] lg:min-w-[110px] min-h-[70px] flex items-center justify-center font-rokh font-[900] text-[19px] text-left bg-white rounded-lg pt-2">
                {content}
              </h2>
            )}
          </>
        )}
      </div>
    );
  };

  const ComparisonCard = ({ title, data, subtitle, link }: any) => {
    return (
      <div
        className={`bg-pr_purple rounded-xl p-3 lg:p-6 flex items-center justify-between`}
        onClick={() => link && navigate(link)}
      >
        {isLoadingStatistical || isLoadingBirthyearStats ? (
          <Loading />
        ) : (
          <div className="flex items-center justify-between w-full">
            <div className="flex-[2] text-right mt-1">
              <h3 className={`font-rokh font-[900] text-lg flex items-center`}>
                {title}
                {link && (
                  <Link to={link}>
                    <HiOutlineArrowLongLeft
                      size={19}
                      className="mr-[6px] -mt-1"
                    />
                  </Link>
                )}
              </h3>
              <p className="text-sm">{subtitle}</p>
            </div>
            <div className="flex-[1] lg:flex-[2] lg:h-[70px] font-rokh font-[900] text-center bg-white rounded-lg flex items-center justify-center flex-col lg:flex-row">
              <div className="flex-1 pt-2 flex flex-row lg:flex-col items-center justify-between lg:justify-center w-full gap-5 lg:gap-1 px-3 lg:px-0">
                <h3 className="text-right text-[12px] lg:text-[13px] font-rokh font-[700] lg:mt-1">
                  {data[1].title}
                </h3>
                <h4 className="text-left text-[15px] lg:text-[19px] font-rokh lg:mt-1">
                  {data[1].content}
                </h4>
              </div>
              <div className="w-full lg:w-[1px] h-[1px] lg:h-full bg-gray-200"></div>

              <div className="flex-1 pt-2 flex flex-row lg:flex-col items-center justify-between lg:justify-center w-full gap-5 lg:gap-1 px-3 lg:px-0">
                <h3 className="text-right text-[12px] lg:text-[13px] font-rokh font-[700] lg:mt-1">
                  {data[0].title}
                </h3>
                <h4 className="text-left text-[15px] lg:text-[19px] font-rokh lg:mt-1">
                  {data[0].content}
                </h4>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const Filters = () => {
    return (
      <div className="flex flex-col justify-between items-center my-10 lg:my-6">
        <h6 className="font-rokh font-[700] text-lg">فیلتر نتایج داشبورد</h6>
        <div className="flex flex-col items-center gap-1 lg:gap-3 w-full">
          <div className="w-full">
            <DatePickerInput
              placeholder="تاریخ شروع"
              id="start_date"
              date={startDate}
              setDate={setStartDate}
              icon={<img src={CalendarIcon} alt="شروع" />}
            />
          </div>
          <div className="w-full -mt-7">
            <DatePickerInput
              placeholder="تاریخ پایان"
              id="end_date"
              date={endDate}
              setDate={setEndDate}
              icon={<img src={CalendarIcon} alt="پایان" />}
            />
          </div>
        </div>
        <button
          onClick={() => {
            fetchStaticData(
              formateDateToGregorian(startDate),
              formateDateToGregorian(endDate)
            );
            fetchBirthyearStatsData(
              formateDateToGregorian(startDate),
              formateDateToGregorian(endDate)
            );
            setIsModalOpen(false);
          }}
          className="btn btn-primary px-8 w-full text-white"
        >
          فیلتر نتایج
        </button>
      </div>
    );
  };

  return (
    <div className="mt-10">
      <div className="flex items-center justify-between mb-10">
        <div>
          <h1 className="font-rokh font-[900] text-xl">
            سلام {profile?.user?.first_name}،
          </h1>
          <p className="font-rokh font-[700]">به داشبورد بادی‌بان خوش اومدی!</p>
        </div>
        <button
          className="btn bg-white border rounded-full px-4 h-10 min-h-[auto]"
          onClick={() => setIsModalOpen(true)}
        >
          <img src={FilterIcon} alt="فیلتر نتایج" className="w-5" />
          <span className="text-sm mr-[1px]">فیلتر</span>
        </button>
      </div>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {Filters()}
        </Modal>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
        {statisticsData?.map((statistic: any, idx: number) => (
          <Card
            key={idx}
            title={statistic.title}
            subtitle={statistic.subtitle}
            link={statistic.link}
            content={statistic.content}
            bgColor="bg-pr_purple"
            color="text-black"
          />
        ))}

        {comparisonData.map((comparison: any, idx: number) => (
          <ComparisonCard
            key={idx}
            title={comparison.title}
            subtitle={comparison.subtitle}
            link={comparison.link}
            data={comparison.data}
          />
        ))}
      </div>
    </div>
  );
};

export default Statistics;
